import React from 'react';

import AchPay from './ach';
import CreditCard from './credit';

const PaymentMethod = (props) => {
  const {
    method,
    authKey,
    chargeAmount,
  } = props;

  if (!authKey || !chargeAmount) return null;

  if (method === 'credit') {
    return (
      <CreditCard
        {...props}
      />
    );
  }
  if (method === 'ach') {
    return (
      <AchPay
        {...props}
      />
    );
  }

  return null;
};

export default PaymentMethod;
